module.exports = __webpack_public_path__ + "static/media/AltoAdige.447ce171.png";